import React, { useContext, useEffect, useState } from "react";
import { Avatar, Col, Divider, Row } from "antd";
import { Text, Title } from "react_reusable_components";

import variables from "../../themes/base/styles/variables";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { AuthService } from "../../services";
import { clearAuthAndLogout } from "../../globalContext/auth/authActions";
import { useNavigate } from "react-router-dom";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import SwitchRoleProfileModal from "../SwitchRoleProfileModal";
import MediaService from "../../services/media-service";

const MyAccountsPopupContentStyle = {
  avatar: {
    background: variables.avatarBG,
    height: variables.avatarLg,
    width: variables.avatarLg,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    margin: `0 ${variables.marginAuto}`,
    fontSize: variables.fontSizeXxlarge,
    fontWeight: variables.fontWeightNormal,
  },
  divider: { backgroundColor: variables.grey5 },
  listItem: {
    display: variables.dFlex,
    marginTop: variables.marginMedium,
    alignItems: variables.alignCenter,
    cursor: "pointer",
    justifyContent: variables.spaceBetween,
  },
  listItemContent: {
    display: variables.dFlex,
    gap: variables.gapXS,
    alignItems: variables.alignCenter,
  },
  popoverContent: {
    width: variables.myAccountPopUpWidth,
    padding: variables.paddingSmall2,
  },
  text: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightNormal,
  },
  title: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    marginTop: variables.marginMediumSmall,
    textAlign: variables.alignCenter,
    marginBottom: 0,
    textTransform: "capitalize",
  },
  iconStyle: {
    width: variables.iconWidth,
    height: variables.iconHeight,
  },
  roleNameStyle: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    fontSize: variables.fontSizeNormal,
    marginTop: variables.marginSmallest,
    fontWeight: variables.fontWeightNormal,
  },
};

export default function MyAccountsPopUpContent({
  handleOpenChange,
  switchProfilePopUp,
  setSwitchProfilePopUp,
}) {
  const [authState, authDispatch] = useContext(AuthContext);
  const navigate = useNavigate();
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [imageDataUrl, setImageDataUrl] = useState("");

  async function onLogOut() {
    await AuthService.logOut({ intl })
      .then(() => {
        authDispatch(clearAuthAndLogout());
      })
      .catch(() => {
        authDispatch(clearAuthAndLogout());
      });
  }

  const intl = useIntl();
  const MyAccountOptions = [
    {
      title: getLocalizedMessage(intl, "nav.switchProfile"),
      icon: (
        <img
          src={"/icons/switch_account.svg"}
          alt={"icon"}
          style={MyAccountsPopupContentStyle.endIconStyle}
        />
      ),
      onClick: () => {
        setSwitchProfilePopUp(true);
      }, //NOSONAR
      endIcon: <img src="/icons/arrow_forward.svg" alt="icon" />,
    },
    {
      title: getLocalizedMessage(intl, "nav.viewMyAccount"),
      icon: (
        <img
          src="/icons/person.svg"
          alt="icon"
          style={MyAccountsPopupContentStyle.endIconStyle}
        />
      ),
      onClick: () => {
        navigate("/my-account");
        handleOpenChange(false);
      },
    },
    {
      title: (
        <Text
          style={{
            ...MyAccountsPopupContentStyle.text,
            color: variables.primaryBg,
          }}
        >
          {getLocalizedMessage(intl, "nav.logOut")}
        </Text>
      ),
      icon: (
        <img
          src="/icons/logout.svg"
          alt="icon"
          style={MyAccountsPopupContentStyle.endIconStyle}
        />
      ),
      onClick: onLogOut,
    },
  ];

  const { name, imageId = "" } = authState?.data || {};

  useEffect(() => {
    if (imageId) {
      MediaService?.getMediaData({
        loaderDispatch,
        mediaId: imageId,
        intl,
      }).then((res) => {
        setImageDataUrl(URL.createObjectURL(res?.data));
      });
    }
  }, [imageId]);

  if (switchProfilePopUp) {
    return (
      <SwitchRoleProfileModal
        onClose={() => setSwitchProfilePopUp(false)}
        userData={authState?.data}
        currentRole={authState?.currentRole}
        handleOpenChange={handleOpenChange}
      />
    );
  }
  return (
    <div style={MyAccountsPopupContentStyle.popoverContent}>
      <Row justify={"center"}>
        <Col>
          <Avatar
            style={{
              ...MyAccountsPopupContentStyle.avatar,
              ...(imageDataUrl?.length > 0 && { background: "none" }),
            }}
            src={imageDataUrl}
          >
            {name?.[0]?.toUpperCase()}
            {name?.split?.(" ")?.[1]?.[0]?.toUpperCase()}
          </Avatar>
          <Title style={MyAccountsPopupContentStyle.title}>{name}</Title>
        </Col>
      </Row>
      <Text style={MyAccountsPopupContentStyle.roleNameStyle}>
        {authState?.currentRole?.fullName}
      </Text>
      <Divider style={MyAccountsPopupContentStyle.divider} />
      {MyAccountOptions.map(({ icon, title, onClick, endIcon }) => (
        <div
          key={title}
          style={MyAccountsPopupContentStyle.listItem}
          onClick={onClick}
        >
          <div style={MyAccountsPopupContentStyle.listItemContent}>
            {icon}
            {typeof title === "string" ? (
              <Text style={MyAccountsPopupContentStyle.text}>{title}</Text>
            ) : (
              title
            )}
          </div>
          {endIcon}
        </div>
      ))}
    </div>
  );
}
